const fromdata = [{
		inputdata: '',
		title: '客户编号',
		fontSize: '14px',
		color: '#333333',
		placeholder: '保存后系统生成',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		disabled: true,
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '客户名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '110px',

	},
	{
		inputdata: '',
		title: '客户简称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		// lablewith: '90px',
	},
	{
		inputdata: '',
		title: '省份',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'province',
		width: '220px',
		btx: true,
		lablewith: '90px',
		options: []
	},
	{
		inputdata: '',
		title: '城市',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'city',
		width: '220px',
		btx: true,
		lablewith: '110px',
		options: []
	},
	{
		inputdata: '',
		title: '区县',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'area',
		width: '220px',
		btx: true,
		// lablewith: '90px',
		options: []
	},
	{
		inputdata: '',
		title: '地址',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '870px',
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '授权状态',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: 'text',
		inputtype: 'radio',
		width: "210px",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: '90px',
		radio: "1"
	},
	{
		inputdata: '',
		title: '客户分类',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		btx: false,
		lablewith: '120px',
		options: [],
		event: 'CusTypeChage'
	},
	{
		inputdata: '',
		title: '科室',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		// lablewith: '90px',
	},
	{
		inputdata: '',
		title: '医生',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '手术类型',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '110px',
	},
	{
		inputdata: '',
		title: '销售人员',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		// lablewith: '90px',
	},
	{
		inputdata: '',
		title: '销售人员上级',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '90px',
	},
	{
		inputdata: '',
		title: '销售人员上上级',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '110px',
	},
	{
		inputdata: '',
		title: '客户等级',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		btx: false,
		lablewith: '80px',
		options: [],
	},
	{
		inputdata: '',
		title: '曾用名',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '90px',
	}, {
		inputdata: '',
		title: '手术量/年',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '110px',
	},
	{
		inputdata: '',
		title: '统一社会信用代码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
		lablewith: '130px',
	},
]
export default fromdata;
